export default {
  welcome: 'Bun venit',
  we_miss_you: 'Ne-ai lipsit',
  happy_friday: 'Vineri fericit',
  lazy_sunday: 'Duminică lenoșă',
  loyalty_program: 'Program de fidelitate',
  you_might_also_like: 'Ți-ar putea plăcea',
  storefront_promo: 'Promoție magazin',
  welcome_members_club: 'Bun venit în club',
  launch_deal: 'Ofertă de lansare',
};
